export default __webpack_public_path__ + "static/media/372.7d746f7c.png";